<template>
  <q-page>
    <h1>This Component $tc</h1>
  </q-page>
</template>

<script>
export default {
  name: 'thisComponent'
}
</script>

<style scoped>

</style>
